module.exports = __webpack_public_path__ + "img/apple-touch-icon.a5751d17.png";